{
  "error.camp.obligatori": "El campo es obligatorio.",
  "error.camp.format": "El formato del campo no es válido.",
  "error.camp.longitud": "La longitud del campo no es válida.",
  "error.id.no.coincideix": "El identificador de la ruta no coincide con el del cuerpo de la petición.",
  "error.permis.denegat": "No tienes permiso para realizar esta acción.",
  "error.tenant.invalid": "Solo se pueden utilizar cuentas corporativas de bonÀrea.",
  "error.no.autenticat": "La sesión ha caducado. Vuelve a iniciar sesión.",
  "error.recurs.no.trobat": "No se ha encontrado el recurso solicitado.",
  "error.etag.no.coincideix": "Los datos han cambiado desde que los consultaste. Vuelve a cargarlos.",
  "error.etag.obligatori": "Es necesario indicar la versión de los datos (cabecera If-Match).",
  "error.activacio.duplicada": "Ya existe una activación idéntica enviada hace poco.",
  "error.activacio.tancada": "La activación ya está cerrada.",
  "error.activacio.critica.no.permesa": "No tienes permiso para crear activaciones críticas.",
  "error.activacio.sense.destinataris": "La activación debe tener como mínimo un destinatario.",
  "error.activacio.servei.o.departament": "Es necesario indicar un servicio o un departamento.",
  "error.activacio.departament.nomes.it": "Solo se puede activar un departamento sin servicio en guardias IT.",
  "error.tancament.motiu": "Es necesario indicar el motivo del cierre.",
  "error.escalat.ultim.nivell": "La activación ya está en el último nivel de escalado.",
  "error.activacio.sense.expert": "El servicio no tiene ningún técnico experto disponible para activar.",
  "error.activacio.no.destinatari": "No figuras como destinatario de esta activación.",
  "error.tipusavis.traduccions": "Es necesario indicar el nombre del tipo de aviso en catalán y en castellano.",
  "error.enviament.sense.contacte": "El destinatario no tiene ningún dato de contacto para este canal.",
  "error.enviament.excepcio": "Se ha producido un error al enviar la notificación.",
  "error.webhook.signatura": "La firma de la petición no es válida.",
  "error.enviament.mailjet": "No se ha podido entregar el correo electrónico.",
  "error.enviament.twilio": "No se ha podido completar la llamada de voz.",
  "error.enviament.push": "No se ha podido entregar la notificación push.",
  "error.torn.solapat": "El turno se solapa con otro turno del mismo calendario.",
  "error.torn.dates": "La fecha de fin del turno debe ser posterior a la de inicio.",
  "error.torn.substitut.igual": "El sustituto no puede ser el mismo que el titular.",
  "error.sollicitud.estat": "La solicitud ya no se puede modificar en el estado actual.",
  "error.rotacio.participants": "La rotación necesita como mínimo un participante.",
  "error.rotacio.periode": "El periodo de la rotación no genera ningún turno.",
  "error.calendari.ambit": "El calendario debe pertenecer a un departamento o a un área, pero no a ambos.",
  "error.torn.passat": "El turno ya ha finalizado.",
  "error.sollicitud.proposat": "La persona propuesta no puede ser la misma que la solicitante.",
  "error.sollicitud.titular": "Solo el titular del turno puede solicitar su cambio.",
  "error.sollicitud.franja": "La nueva franja debe estar dentro del turno original.",
  "error.sollicitud.intercanvi": "El turno de intercambio debe ser del mismo calendario y tener como titular a la persona propuesta.",
  "error.document.format": "El formato del fichero no está permitido.",
  "error.document.mida": "El fichero supera el tamaño máximo permitido.",
  "error.document.limit": "Se ha alcanzado el número máximo de documentos del servicio.",
  "error.document.malware": "El fichero no ha superado el análisis antimalware.",
  "error.document.bloquejat": "El documento está bloqueado o retirado.",
  "error.document.retirat": "El documento está retirado y no se puede modificar ni descargar.",
  "error.missatge.mencio": "La mención no corresponde a ninguna persona, servicio o departamento válido.",
  "error.ws.topic": "Debe indicarse el canal de tiempo real.",
  "error.ws.missatge": "El mensaje de tiempo real no es válido.",
  "error.import.fitxer": "No se ha podido leer el fichero de importación.",
  "error.import.columna": "Falta una columna obligatoria en el fichero de importación.",
  "error.import.email": "La dirección de correo no es válida.",
  "error.import.duplicat": "La dirección de correo ya está dada de alta en el servicio.",
  "error.import.canal": "El canal indicado no es válido.",
  "error.codi.duplicat": "Ya existe un registro con este código.",
  "error.circuit.desti": "El nivel de escalado necesita un destinatario.",
  "error.expert.titular.obligatori": "El servicio debe tener un técnico experto titular.",
  "error.expert.duplicat": "La persona ya está asignada como experta del servicio.",
  "error.escalat.ja.notificat": "Esta persona ya ha sido avisada en esta activación.",
  "error.ambit.id": "Es necesario indicar el área, el servicio o el departamento de la asignación.",
  "error.rol.dates": "La fecha de fin de la asignación debe ser posterior a la de inicio.",
  "error.circuit.defecte.unic": "Solo puede haber un circuito de escalado por defecto.",
  "error.circuit.sense.nivells": "El circuito de escalado debe tener como mínimo un nivel.",
  "error.plantilla.variable": "La plantilla contiene una variable desconocida.",
  "error.rol.sistema": "Los roles del sistema no se pueden eliminar.",
  "error.integracio.no.disponible": "La integración externa no está disponible en este momento.",
  "error.app.versio.minima": "Es necesario actualizar la aplicación a la versión mínima obligatoria.",
  "error.plantilla.tipus": "El tipo de plantilla no es válido.",
  "error.plantilla.traduccio": "La plantilla debe tener traducción en catalán y castellano.",
  "error.app.versio": "El número de versión no es válido.",
  "error.app.missatge.tipus": "El tipo de mensaje administrativo no es válido.",
  "error.configuracio.clau": "La clave de configuración no existe.",
  "error.configuracio.valor": "El valor de configuración no es válido.",
  "error.informe.format": "El formato de informe no es válido (pdf, csv o xlsx).",
  "error.informe.cron": "La expresión de programación (cron) no es válida.",
  "error.informe.tipus": "El tipo de informe no es válido.",
  "error.peticio.invalida": "La petición no es válida.",
  "error.metode.no.permes": "El método no está permitido.",
  "error.intern": "Se ha producido un error inesperado. Vuelve a intentarlo más tarde.",
  "error.desconegut": "Se ha producido un error inesperado.",
  "error.xarxa": "No se puede conectar con el servidor.",
  "error.usuari.no.existeix.entra": "Este usuario ya no existe en Entra ID.",
  "error.usuari.camp.no.sincronitzable": "Este campo no se puede sincronizar con Entra ID.",
  "error.document.no.retirat": "Solo se puede restaurar un documento retirado.",
  "error.document.restaurar.sense.versio": "El documento no tiene ninguna versión limpia para volver a publicarlo.",
  "error.circuit.defecte.inactiu": "El circuito por defecto debe estar activo.",
  "error.usuari.telefon.mobil": "El móvil debe tener 9 dígitos y empezar por 6 o 7.",
  "error.rol.no.assignable": "No puedes asignar un rol con más permisos que los tuyos.",
  "error.usuari.ja.existeix": "Esta persona ya está dada de alta en el CAI.",
  "error.amb.camp": "{{missatge}} Campo afectado: «{{camp}}».",
  "camp.actiu": "Activo",
  "camp.activacio": "Activación",
  "camp.adreca": "Dirección",
  "camp.ambit": "Ámbito",
  "camp.ambitId": "Departamento, área o servicio",
  "camp.appVersio": "Versión de la app",
  "camp.area": "Área",
  "camp.areaId": "Área",
  "camp.calendari": "Calendario",
  "camp.calendariId": "Calendario",
  "camp.camps": "Campos",
  "camp.canals": "Canales",
  "camp.canalsDefecte": "Canales por defecto",
  "camp.carrec": "Cargo",
  "camp.categoria": "Categoría",
  "camp.circuit": "Circuito",
  "camp.codi": "Código",
  "camp.color": "Color",
  "camp.comentari": "Comentario",
  "camp.contacteId": "Contacto",
  "camp.contacteText": "Contacto",
  "camp.critica": "Crítica",
  "camp.cron": "Programación",
  "camp.departament": "Departamento",
  "camp.departamentId": "Departamento",
  "camp.descripcio": "Descripción",
  "camp.desde": "Desde",
  "camp.destiId": "Destinatario",
  "camp.destinataris": "Destinatarios",
  "camp.diaInici": "Día de inicio",
  "camp.email": "Correo",
  "camp.entraGroupId": "Grupo de Entra ID",
  "camp.entraOid": "Persona de Entra ID",
  "camp.especialitat": "Especialidad",
  "camp.esperaSeg": "Tiempo de espera",
  "camp.experts": "Expertos",
  "camp.fi": "Fin",
  "camp.fins": "Hasta",
  "camp.fitxer": "Fichero",
  "camp.format": "Formato",
  "camp.formats": "Formatos",
  "camp.fusHorari": "Huso horario",
  "camp.grup": "Grupo",
  "camp.horaCanvi": "Hora de cambio",
  "camp.idioma": "Idioma",
  "camp.inici": "Inicio",
  "camp.maxDocuments": "Número máximo de documentos",
  "camp.mencions": "Menciones",
  "camp.mesures": "Medidas",
  "camp.mesuresPendents": "Medidas pendientes",
  "camp.midaMaxMb": "Tamaño máximo",
  "camp.missatge": "Mensaje",
  "camp.missatgeFinalitzacio": "Mensaje de finalización",
  "camp.motiu": "Motivo",
  "camp.nivells": "Niveles",
  "camp.nom": "Nombre",
  "camp.nomCa": "Nombre en catalán",
  "camp.nomEs": "Nombre en castellano",
  "camp.notes": "Notas",
  "camp.nouFi": "Nuevo fin",
  "camp.nouInici": "Nuevo inicio",
  "camp.participants": "Participantes",
  "camp.perills": "Peligros",
  "camp.periodicitat": "Periodicidad",
  "camp.plantillaId": "Plantilla",
  "camp.proposatId": "Persona propuesta",
  "camp.provesRealitzades": "Pruebas realizadas",
  "camp.recordatoriMinuts": "Recordatorio",
  "camp.recurs": "Recurso",
  "camp.ref": "Referencia",
  "camp.responsableId": "Responsable",
  "camp.risc": "Riesgo",
  "camp.rol": "Rol",
  "camp.rolId": "Rol",
  "camp.rotacio": "Rotación",
  "camp.servei": "Servicio",
  "camp.serveiId": "Servicio",
  "camp.serveiIds": "Servicios",
  "camp.substitutId": "Sustituto",
  "camp.tancament": "Cierre",
  "camp.telefon": "Teléfono",
  "camp.tempsConfirmacioSeg": "Tiempo de confirmación",
  "camp.text": "Texto",
  "camp.tipus": "Tipo",
  "camp.tipusAvis": "Tipo de aviso",
  "camp.tipusAvisId": "Tipo de aviso",
  "camp.tipusBase": "Tipo base",
  "camp.tipusDesti": "Tipo de destinatario",
  "camp.titol": "Título",
  "camp.titularId": "Titular",
  "camp.torn": "Turno",
  "camp.tornId": "Turno",
  "camp.tornIntercanviId": "Turno de intercambio",
  "camp.traduccions": "Traducciones",
  "camp.url": "URL",
  "camp.usuari": "Persona",
  "camp.usuariId": "Persona",
  "camp.usuariInformar": "Persona a informar",
  "camp.variables": "Variables",
  "camp.versio": "Versión",
  "camp.versioMax": "Versión máxima",
  "camp.versioMin": "Versión mínima",
  "camp.zona": "Zona",
  "camp.zonaId": "Zona",
  "camp.zonaText": "Zona"
}
